import React from 'react'

export default function CodeBlock({ code }: { code: string | undefined }) {
  if (!code) return null
  return (
    <div className="bg-gray-800 rounded-lg">
      <pre className="p-4 whitespace-pre-wrap break-all">
        <code className="text-sm font-mono text-gray-100">{code}</code>
      </pre>
    </div>
  )
}
